<template>

  <div class="wrapper">
    <div class="img-wrapper" >
      <img v-for="(img,index ) in imgs" class="add-img" :src="imgs[index]" :key="index"/>

<!-- 
      <img class="add-img" src="../../assets/imgs/xunlonggaoshou/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/xunlonggaoshou/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/xunlonggaoshou/3.jpg" alt=""> -->
    </div>


    <!-- <div class="img-wrapper" v-if="goodsId == 10">
      <img class="add-img" src="../../assets/imgs/xunlonggaoshou/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/xunlonggaoshou/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/xunlonggaoshou/3.jpg" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 9">
      <img class="add-img" src="../../assets/imgs/legao/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/legao/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/legao/3.jpg" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 8">
      <img class="add-img" src="../../assets/imgs/dishini/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/dishini/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/dishini/3.jpg" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 7">
      <img class="add-img" src="../../assets/imgs/yinyuedeng/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/yinyuedeng/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/yinyuedeng/3.jpg" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 6">
      <img class="add-img" src="../../assets/imgs/youxiji/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/youxiji/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/youxiji/3.jpg" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 5">
      <img class="add-img" src="../../assets/imgs/pintu/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/pintu/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/pintu/3.jpg" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 4">
      <img class="add-img" src="../../assets/imgs/legao/1.png" alt="">
      <img class="add-img" src="../../assets/imgs/legao/2.png" alt="">
      <img class="add-img" src="../../assets/imgs/legao/3.png" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 3">
      <img class="add-img" src="../../assets/imgs/gongzhumanghe/1.png" alt="">
      <img class="add-img" src="../../assets/imgs/gongzhumanghe/2.png" alt="">
      <img class="add-img" src="../../assets/imgs/gongzhumanghe/3.png" alt="">
      <img class="add-img" src="../../assets/imgs/gongzhumanghe/4.png" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 2">
      <img class="add-img" src="../../assets/imgs/xiaoshuo/1.png" alt="">
      <img class="add-img" src="../../assets/imgs/xiaoshuo/2.png" alt="">
      <img class="add-img" src="../../assets/imgs/xiaoshuo/3.png" alt="">
      <img class="add-img" src="../../assets/imgs/xiaoshuo/4.png" alt="">
    </div>
    <div class="img-wrapper" v-if="goodsId == 1">
      <img class="add-img" src="../../assets/imgs/yinyuedeng/1.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/yinyuedeng/2.jpg" alt="">
      <img class="add-img" src="../../assets/imgs/yinyuedeng/3.jpg" alt="">
    </div> -->
  </div>

</template>

<script>
import {GOODS_INFO} from "@/contants/goods"
import _ from "lodash"
  export default {
    name: "GoodsUrlPage",
    data(){
      return {
        goodsId: '',
      }
    },
    computed:{
      imgs() {
        return _.get(GOODS_INFO,[this.$route.query.goodsId,"imgs"])
      },
    },
    created() {
      this.goodsId = this.$route.query.goodsId;
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .add-img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// app/pages/tabs/ScoreShop/GoodsUrlPage.vue